import resaleAgreements from "./resale-agreements"
import timeline from "./timeline"
import types from "./types"
import revisions from "./revisions"
import enedisContractSubscriptionTypes from "./enedis-contract-subscription-types"
import requiredFields from "./required-fields"
import mandate from "./mandates"
import solarPanelTiltForm from "./solar-panel-tilt-form"
import statistics from "./statistics"

export default {
  "resale-agreements": resaleAgreements,
  "required-fields": requiredFields,
  mandate: mandate,
  "solar-panel-tilt-form": solarPanelTiltForm,
  revisions,
  statistics,
  timeline,
  types,
  "enedis-contract-subscription-types": enedisContractSubscriptionTypes,
  mayor: {
    contactCard: {
      website: "Site web",
      plans: "Plans",
      phone: "Telephone du standard",
      email: "Email du standard",
      "urban-planning-phone": "Telephone du service d'urbanisme",
      "urban-planning-email": "Email du service d'urbanisme",
    },
  },
  services: {
    ALL: "Tous les dossiers",
    CONSUEL: "Visa Consuel (en résidentiel)",
    CONSUEL_LARGE_PRODUCER: "Visa Consuel (en tertiaire)",
    MAYOR: "Autorisation d'urbanisme (en résidentiel)",
    MAYOR_LARGE_PRODUCER: "Autorisation d'urbanisme (en tertiaire)",
    GRID_CONNECTION: "Raccordements (< 36 kVA)",
    GRID_CONNECTION_LARGE_PRODUCER: "Raccordements (36-250 kVA)",
    GRID_CONNECTION_LARGE_PRODUCER_HTA_250_TO_500_KVA:
      "Raccordements (250-500 kVA)",
    GRID_CONNECTION_LARGE_PRODUCER_HTA_ABOVE_500_KVA: "Raccordements (>500 kVA)",
    RESALE_AGREEMENT: "Contrats d’achat",
    GRID_CONNECTION_LARGE_PRODUCER_HTA_250_TO_500_KVA:
      "Raccordements (250-500 kVA)",
    GRID_CONNECTION_LARGE_PRODUCER_HTA_ABOVE_500_KVA: "Raccordements (>500 kVA)",
    LARGE_PRODUCER_FOR_HOUSING: "En résidentiel",
    LARGE_PRODUCER_FOR_COMMERCIAL: "En tertiaire",
  },
  "information-missing": {
    title: "Certaines informations sont manquantes.",
    "add-buffer": " Ajouter tampon",
    "add-signature": "Ajouter signature",
    "add-head-office-address": "Ajouter l'adresse du siège",
  },
  installer: {
    "communication-preference": {
      label: "Mode de communication préféré :",
      PHONE: "Téléphone",
      EMAIL_FORMAL: "Email (Formel)",
      FLEXIBLE: "Flexible",
      NONE: "Aucun",
    },
    "communication-policy-dialog": {
      "notes-label": "Remarque sur la communication avec cet installateur :",
      PHONE: {
        title: "Cet installateur préfère être contacté par téléphone",
      },
      EMAIL_FORMAL: {
        title: "Cet installateur préfère être contacté par email formel",
      },
      FLEXIBLE: {
        title: "Cet installateur est flexible sur le mode de communication",
      },
      NONE: {
        title:
          "Cet installateur n'a pas de préférence de communication spécifiée",
      },
    },
  },
}
